import { DialogBody } from 'client/components/core/Dialog'
import styled from 'styled-components'

export const ThreeDsWrapper = styled(DialogBody)`
  display: flex;
  padding: 0;
`
